/* global G */
import ui from 'lib/hook/ui/update'

const _baseHooks = {
  before: [
    ui,
  ]
}

const hooks = {
  [G.ACTIONS]: {
    index: _baseHooks,
    bottomSheet: _baseHooks
  },
}

export default hooks
